import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/pharmacy")({
  head: () =>
    buildHead({
      path: "/pharmacy",
      jsonLd: buildFaqJsonLd(FAQS["/pharmacy"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Pharmacies & Drugstores", url: `${SITE_URL}/pharmacy` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/PharmacyLanding")),
});
